import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Spotlight from "../components/Spotlight";
import StatsCounter from "../components/StatsCounter";
import Customers from "../components/Customers";
import Ports from "../components/Ports";
import LiveChat from "../components/LiveChat";
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";
import AdPreloader from "../components/AdPerloader";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import "../App.css";

const services = [
  {
    title: "Marine Engineering Services",
    description:
      "Professional maintenance and overhauls of marine engines and systems.",
    className: "marine-machinery",
    link: "/sectors/marine",
  },
  {
    title: "Pre-Docking Solutions",
    description: "Resolving issues in CPP systems and Fixed Propeller.",
    className: "automation-troubleshooting",
    link: "/sectors/docking",
  },
  {
    title: "Ship & Boat Building",
    description:
      "Custom steel and pipeline fabrication handled by expert teams.",
    className: "fabrication-services",
    link: "/sectors/shipbuild",
  },
  {
    title: "Husbandry Services",
    description:
      "Servicing of domestic and industrial refrigeration systems onboard.",
    className: "refrigeration-solutions",
    link: "/sectors/husbandry",
  },
  {
    title: "Spares & Store Supply",
    description:
      "Troubleshooting boiler, motor and LT cooler control circuits.",
    className: "electrical-control-systems",
    link: "/sectors/spares",
  },
  {
    title: "Industrial Engineering",
    description:
      "Troubleshooting boiler, motor and LT cooler control circuits.",
    className: "industrial-engineering",
    link: "/sectors/industrial",
  },
];

const Home = () => {
  const [showAd, setShowAd] = useState(true); // Ad preloader disabled by default

  useEffect(() => {
    // When ad is shown, disable scroll; otherwise ensure scroll is enabled
    if (showAd) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      // Clean up: always restore scroll
      document.body.style.overflow = "auto";
    };
  }, [showAd]);

  const handleAdEnd = () => {
    setShowAd(false); // When ad ends or is skipped
  };
  void handleAdEnd; // Keep reference ready if ad is re-enabled without ESLint warning

  return (
    <div className="home-wrapper">
      <Navbar />
      <header className="hero-section" id="home">
      {/* <div className="hhero-overlay"></div> */}
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          style={{
            width: "100%",
            height: "100vh",
            objectFit: "cover",
          }}
        >
          <source
            src="/videos/1474411-uhd_4096_2160_24fps.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <StatsCounter />

        {/* Show Ad overlay */}
        {showAd && <AdPreloader onAdEnd={handleAdEnd} />} 
      </header>

      {/* Main Content */}
      { (
        <>
          <div className="home-intro">
            <h1>
              Leading Marine Engineering & Ship Building Services in Sri Lanka{" "}
            </h1>
            <h2>
              Your Trusted Partner for Total Marine and Engineering Solutions!
            </h2>
            {/* <h3> Serving Sri Lanka, South Asia, Middle East & Asia-Pacific with Professional Maritime Excellence</h3> */}
            <p className="home-section">
              Welcome to CIAP (PVT) LTD, a leading marine engineering company in
              Sri Lanka that embraces excellence in Marine and Industrial
              Engineering innovation. With a team of highly skilled Engineers
              and Technicians, we are experts in Marine & Engineering Solutions,
              Ship and Boat building, and comprehensive maritime services. Our
              commitment to quality and professionalism ensures that we provide
              the highest level of services to local and international clients
              across South Asia, Middle East, and Asia-Pacific regions, helping
              them achieve efficiency, safety and reliability in every project.
            </p>
            <p className="home-section">
              We offer a comprehensive range of maritime services to support the
              shipping industry, including Pre-Dock repairs, Ship and Boat
              repairs, Marine Engineering Services, Husbandry Services, Vessel
              operations, and Industrial Engineering solutions. Working closely
              with ship owners, operators and charterers, we tailor our
              solutions to meet their specific needs. Our expertise spans across
              marine engine maintenance, propeller systems, refrigeration
              solutions, electrical control systems, and custom fabrication
              services. We are dedicated to navigating excellence at every turn,
              making us your trusted partner for all your Marine and Engineering
              needs in Sri Lanka and beyond.
            </p>
            <p className="home-section">
              As a trusted marine engineering partner, CIAP serves major ports
              across Sri Lanka including Colombo, Hambantota, Galle, and
              Trincomalee, while extending our professional services to clients
              throughout South Asia, the Middle East, and the broader
              Asia-Pacific region. Our strategic location in Sri Lanka positions
              us perfectly to serve the international shipping industry with
              rapid response times and cost-effective solutions.
            </p>
          </div>

          <GetQuoteButton />

          <section className="core-services-section">
            <h2 className="core-services-heading">Our Core Services</h2>
            <div className="core-services-grid">
              {services.map((service, index) => (
                <Link
                  to={service.link}
                  key={index}
                  className={`core-service-card ${service.className}`}
                >
                  {/* The Overlay */}
                  <div className="card-overlay"></div>

                  <div className="card-content">
                    <h3 className="card-title">{service.title}</h3>
                    <p className="card-description">{service.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </section>

          <Spotlight />
          <Ports />

          <ScrollSocialIcons />
          <Customers />
          <BackToTopButton />
          <LiveChat />
          <QAChatbot />
          <Footer />
          <SpeedInsights />
          <Analytics />
        </>
      )}
    </div>
  );
};

export default Home;
